var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('v-icon',{attrs:{"size":"1.75rem"}},[_vm._v(" mdi-check-circle ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }